import type { Image } from 'types'
import imgSizes from 'ui-component-library/utils/imgSizes'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import { InlineImage } from 'content-components/_Primatives/Images'
import Link from 'content-components/_Primatives/Link'
import Ruler from '../00-Primitives/Ruler'
import style from './style.scss'

type Partner = {
  name: string
  url: string
  image: Image
}

type Props = {
  headlineText: string
  partners: Partner[]
}

function FeaturedPartners({ partners, headlineText }: Props) {
  return (
    <div className={style.wrapper}>
      <HeadlineTwo className={style.headline}>{headlineText}</HeadlineTwo>
      <Ruler className={style.ruler} />
      <div className={style.partners}>
        {partners.map((partner) => {
          const { name, url, image } = partner
          return (
            <Link key={name} className={style.partner} url={url}>
              <InlineImage
                className={style.logo}
                gradient={false}
                sizes={imgSizes(null, null, 230)}
                image={image}
              />
            </Link>
          )
        })}
      </div>{' '}
    </div>
  )
}

export default FeaturedPartners
